import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import UIButton from 'UIComponents/button/UIButton';
import UIDialog from 'UIComponents/dialog/UIDialog';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import { events } from 'growth-payments-core/usage-tracker/events';
import { track } from 'growth-payments-core/usage-tracker/track';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var CANCEL_MODAL_ACTION;
(function (CANCEL_MODAL_ACTION) {
  CANCEL_MODAL_ACTION["GoBack"] = "cancelModalGoBackButtonClicked";
  CANCEL_MODAL_ACTION["Confirm"] = "cancelModalConfirmButtonClicked";
})(CANCEL_MODAL_ACTION || (CANCEL_MODAL_ACTION = {}));
export const TEST_IDS = {
  CANCEL_MODAL_CONFIRM_BUTTON: 'cancel-modal-confirm-button'
};
export const trackCancelModalInteraction = action => {
  track(events.paymentSettingsInteraction, {
    action,
    location: 'cancel-modal'
  });
};
const CancelModal = ({
  onConfirm,
  onGoBack
}) => /*#__PURE__*/_jsx(UIModal, {
  use: "conversational",
  width: 500,
  children: /*#__PURE__*/_jsxs(UIDialog, {
    centered: false,
    children: [/*#__PURE__*/_jsx(UIDialogHeader, {
      className: "m-bottom-2",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h4",
        textAlign: "start",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CancelModal.header"
        })
      })
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      style: {
        textAlign: 'left'
      },
      className: "m-bottom-4",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "CancelModal.description"
      })
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        "data-test-id": TEST_IDS.CANCEL_MODAL_CONFIRM_BUTTON,
        onClick: () => {
          trackCancelModalInteraction(CANCEL_MODAL_ACTION.Confirm);
          onConfirm();
        },
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CancelModal.cancel"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        onClick: () => {
          trackCancelModalInteraction(CANCEL_MODAL_ACTION.GoBack);
          onGoBack();
        },
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "CancelModal.goBack"
        })
      })]
    })]
  })
});
export default CancelModal;